import React from 'react';

import { IonBadge } from '@ionic/react';

import clsx from 'clsx';

import './index.css';

interface BadgeConfig {
  children?: any;
  className?: string;
  color?: string;
}

export const Badge: React.FC<BadgeConfig> = ({
  children,
  className,
  color,
  ...props
}) => {
  return (
    <IonBadge
      className={clsx(
        'badge',
        `ion-color-status-${color}`,
        'filled',
        className
      )}
      {...props}
    >
      {children}
    </IonBadge>
  );
};
